// removed by extract-text-webpack-plugin
module.exports = {"result":"result___1_iIA","icon":"icon___32976","success":"success___efK74","error":"error___dBMCt","title":"title___3Sr88","description":"description___2Ofvx","extra":"extra___1v8i7","actions":"actions___3GMzM"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Result/index.less
// module id = 439
// module chunks = 0 1